import { Component, inject, Inject } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TrailSetup } from '../../dto/trail-setup';
import { TrailPropertiesService } from '../../service/trail-properties.service';
import { BoolDto } from '../../../../common/dto/bool-dto';

@Component({
  selector: 'dpi-trail-setup-details',
  imports: [MatInputModule, MatFormFieldModule, MatSelectModule, FormsModule, MatButtonModule, MatIconModule, MatDialogModule],
  templateUrl: './trail-setup-details.component.html',
  styleUrl: './trail-setup-details.component.scss'
})
export class TrailSetupDetailsComponent {
  readonly dialogRef = inject(MatDialogRef<TrailSetupDetailsComponent>);
  trailSetup: TrailSetup;
  isToUpdate: boolean;
  isToDelete: boolean;

  confirmedStates: BoolDto[];
  selectedState: BoolDto;

  constructor(@Inject(MAT_DIALOG_DATA) public data: TrailSetup, private trailPropertiesService: TrailPropertiesService  ) {
    this.trailSetup = data;

    this.confirmedStates = this.trailPropertiesService.getAllTrialBinaryStates();
    this.selectedState = this.trailPropertiesService.getTrialSetupBinaryState(this.confirmedStates, data.confirmed);

    this.isToUpdate = false;
    this.isToDelete = false;
  }


  onCancelClick(): void {
    this.dialogRef.close();
  }

  onUpdateClick() {
    this.trailSetup.confirmed = this.selectedState.state;
    this.isToUpdate = true;
  }

  onDeleteClick() {
    this.isToDelete = true;
    this.dialogRef.close();
  }

}
